'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _pify = require('pify');

var _pify2 = _interopRequireDefault(_pify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	apiKey: {
		type: 'string'
	},
	class: {
		type: 'string'
	},
	description: {
		type: 'string'
	},
	header: {
		type: 'string'
	},
	height: {
		type: 'string'
	},
	icon: {
		type: 'string'
	},
	image: {
		type: 'string'
	},
	lat: {
		type: 'number'
	},
	lng: {
		type: 'number'
	},
	theme: {
		type: 'object'
	},
	title: {
		type: 'string'
	},
	zoom: {
		type: 'number'
	}
};

var defaultProps = {
	apiKey: 'AIzaSyCeJqyd3hlNMYOVUigRlO08dcIr_Nm5G4I',
	height: '500px',
	lat: 57.715595,
	lng: 12.938492,
	zoom: 14
};

var getContentString = function getContentString(image, header, description) {
	var img = image ? '<div class=\'InfoWindow-image\'><img src=\'' + image + '\' alt=\'' + header + '\'/></div>' : '';

	return '<div class=\'InfoWindow-wrapper\'>' + img + '<div><h1>' + header + '</h1><p>' + description + '</p></div></div>';
};

var loadGoogleScript = function loadGoogleScript(apiKey) {
	if (typeof window.google !== 'undefined' && window.google.maps) {
		return Promise.resolve();
	}

	return (0, _pify2.default)(_loadScript2.default)('https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=geometry');
};

var afterRender = function afterRender(_ref, el) {
	var id = _ref.id,
	    props = _ref.props;
	var description = props.description,
	    header = props.header,
	    icon = props.icon,
	    image = props.image,
	    lat = props.lat,
	    lng = props.lng,
	    theme = props.theme,
	    title = props.title,
	    zoom = props.zoom;

	var uluru = { lat: lat, lng: lng };
	var element = el.querySelector('#deku-google-map-' + id);

	loadGoogleScript(props.apiKey).then(function () {
		var map = new window.google.maps.Map(element, {
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			center: uluru,
			zoom: zoom,
			styles: theme
		});

		var marker = new window.google.maps.Marker({
			position: uluru,
			animation: window.google.maps.Animation.DROP,
			map: map,
			icon: icon,
			title: title
		});

		if (header && description) {
			var infowindow = new window.google.maps.InfoWindow({ content: getContentString(image, header, description) });
			marker.addListener('click', function () {
				infowindow.open(map, marker);
			});
		}

		window.google.maps.event.addDomListener(window, 'resize', function () {
			map.setCenter(uluru);
		});
	});
};

var shouldUpdate = function shouldUpdate(_ref2, nextProps) {
	var props = _ref2.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref3) {
	var id = _ref3.id,
	    props = _ref3.props;
	var height = props.height,
	    styleClasses = props.styleClasses;

	var date = new Date().getTime();

	var style = {
		width: '100%',
		height: height
	};

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['DekuGoogleMap', props.class, styleClasses && styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)('div', { key: date, id: 'deku-google-map-' + id, 'class': styleClasses && styleClasses.Map, 'data-style-attr': 'Map', style: (!styleClasses || styleClasses && styleClasses.Map) && style })
	);
};

exports.default = { afterRender: afterRender, defaultProps: defaultProps, render: render, propTypes: propTypes, shouldUpdate: shouldUpdate };